import { Button, Stack, Text } from '@chakra-ui/react'

import useAPIWrapper from '@/client/hooks/useAPIWrapper'
import { RPCRefresh } from '@/client/rpc'

import ModalV3 from '@/components/UI/Modal/ModalV3'

export default function CancelLiveHelpRequestModal({
  postId,
  open,
  onClose,
}: {
  postId: number
  open: boolean
  onClose: () => void
}): JSX.Element {
  const [handleCancelRequest, isCancelling] = useAPIWrapper(
    async () => {
      await RPCRefresh.cancelLiveHelpRequest({
        postId,
      })
      onClose()
    },
    [postId, onClose],
    'Cancel Live Help Request'
  )

  return (
    <ModalV3
      size="xl"
      open={open}
      onClose={onClose}
      title="Stop requesting Zoom help"
      body={() => <Text>Are you sure you want to stop requesting Zoom help?</Text>}
      rightFooterContent={() => (
        <Stack direction="row" spacing="8px">
          <Button variant="outline" onClick={onClose}>
            Continue Waiting
          </Button>
          <Button isLoading={isCancelling} onClick={handleCancelRequest}>
            Stop Requesting
          </Button>
        </Stack>
      )}
    />
  )
}
